import script from "./train_modal.vue?vue&type=script&setup=true&lang=js"
export * from "./train_modal.vue?vue&type=script&setup=true&lang=js"

import "./train_modal.vue?vue&type=style&index=0&id=1c431a9e&lang=less&scoped=true"

import exportComponent from "/usr/local/jenkins/workspace/pc-web_pc-pre/node_modules/@vue/cli-service/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-1c431a9e"]])

export default __exports__